import { useState, useEffect } from "react";
import { useBootstrap } from "@/features/bootstrap";
import { ToggleSwitch } from "../components/ToggleSwitch";
import { ROLES } from "@/features/router/roles";
import { updatePrivacy } from "@/api/users.api";

export function PrivacySection(props) {
  const { dataUse: initialDataUse, setDataUse } = props;
  const { data: user } = useBootstrap();
  const isStudent = user?.role === ROLES.STUDENT;

  const [dataUse, setLocalDataUse] = useState(initialDataUse);
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    setLocalDataUse(initialDataUse);
  }, [initialDataUse]);

  async function handleToggle(val) {
    setLocalDataUse(val);
    setDataUse?.(val);

    try {
      setIsPending(true);
      await updatePrivacy(val);
    } catch {
      setLocalDataUse(!val);
      setDataUse?.(!val);
    } finally {
      setIsPending(false);
    }
  }

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 p-3 border border-[#DDDDDD] rounded">
      <div className="flex flex-col gap-1">
        <span className="text-[16px] font-bold">
          {isStudent
            ? "Allow teachers and administrators to view my data"
            : "Data sharing"}
        </span>
        <span className="text-[16px] opacity-50">
          {isStudent
            ? 'Selecting "on" means your teachers and administrators can view your wellness data to better support you. Even when this is off, if you write certain words that could mean you or someone else may be in danger, an alert with what you wrote is sent to the right staff at your school, so they can decide how to help.'
            : 'For students, selecting "on" means teachers and administrators can view their wellness data to better support them. Even when a student turns this off, if they write certain words that could mean they or someone else may be in danger, an alert with that message is sent to the appropriate school staff, who decide how to respond. None of the student\'s other data is shared. This toggle does not apply to adults (your data is not shared with others)'}
        </span>
      </div>
      <div className="ml-auto">
        <ToggleSwitch
          checked={dataUse}
          onCheckedChange={handleToggle}
          disabled={isPending}
        />
      </div>
    </div>
  );
}
